import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=d1fbe56a&"
import script from "./NewDetail.vue?vue&type=script&lang=js&"
export * from "./NewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports